import React, { useState, useEffect } from 'react';

const EventsList = ({ }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    search: '',
    upcoming: true,
    past: false,
    registered: false,
    clubId: null
  });
  const [qrModal, setQrModal] = useState(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    perPage: 12
  });

  useEffect(() => {
    loadEvents();
  }, [filters, pagination.currentPage]);

  const loadEvents = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: pagination.currentPage,
        per_page: pagination.perPage,
        ...(filters.search && { search: filters.search }),
        ...(filters.upcoming && !filters.registered && { upcoming: 'true' }),
        ...(filters.past && !filters.registered && { past: 'true' }),
        ...(filters.registered && { registered: 'true' }),
        ...(filters.clubId && { club_id: filters.clubId })
      });

      const response = await fetch(`/api/v1/events?${params}`, {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      });

      const data = await response.json();
      
      if (data.success) {
        setEvents(data.events);
        setPagination(prev => ({
          ...prev,
          totalPages: data.pagination.total_pages,
          currentPage: data.pagination.current_page
        }));
      }
    } catch (error) {
      console.error('Erreur lors du chargement des événements:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPagination(prev => ({ ...prev, currentPage: 1 }));
    loadEvents();
  };

  const fetchQrCode = async (eventId) => {
    try {
      const res = await fetch(`/api/v1/events/${eventId}/qr_code`, {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      });
      const data = await res.json();
      if (data.success) {
        setQrModal({
          eventId,
          qrData: data.qr_code_data || data.qr_code_token,
          registrationId: data.registration_id
        });
      }
    } catch (error) {
      console.error('Erreur QR Code:', error);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusBadge = (event) => {
    if (event.user_registered) {
      return (
        <span style={{
          background: 'rgba(34, 197, 94, 0.15)',
          color: '#4ade80',
          padding: '6px 14px',
          borderRadius: '20px',
          fontSize: '0.85rem',
          fontWeight: '600',
          border: '1px solid rgba(34, 197, 94, 0.35)'
        }}>
          ✓ Inscrit
        </span>
      );
    }
    if (!event.registration_open) {
      return (
        <span style={{
          background: 'rgba(150, 150, 170, 0.1)',
          color: '#6b7280',
          padding: '6px 14px',
          borderRadius: '20px',
          fontSize: '0.85rem',
          fontWeight: '600',
          border: '1px solid rgba(107, 114, 128, 0.3)'
        }}>
          Fermé
        </span>
      );
    }
    if (event.spots_remaining === 0) {
      return (
        <span style={{
          background: 'rgba(245, 158, 11, 0.2)',
          color: '#fbbf24',
          padding: '6px 14px',
          borderRadius: '20px',
          fontSize: '0.85rem',
          fontWeight: '600',
          border: '1px solid rgba(245, 158, 11, 0.35)'
        }}>
          Complet
        </span>
      );
    }
    return (
      <span style={{
        background: 'linear-gradient(135deg, #7c2837 0%, #943143 50%, #a8384e 100%)',
        color: 'white',
        padding: '6px 14px',
        borderRadius: '20px',
        fontSize: '0.85rem',
        fontWeight: '600'
      }}>
        Ouvert
      </span>
    );
  };

  return (
    <div className="event-mobile-shell events-list-page" style={{ 
      fontFamily: 'Poppins, sans-serif', 
      background: '#f7eef2',
      minHeight: '100vh',
      paddingTop: '120px',
      paddingBottom: '80px'
    }}>
      {/* Modal QR Code */}
      {qrModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(44,14,22,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }} onClick={() => setQrModal(null)}>
          <div style={{ background: '#fff', borderRadius: 24, padding: '36px 32px', maxWidth: 400, width: '100%', boxShadow: '0 24px 64px rgba(44,14,22,0.3)', textAlign: 'center' }} onClick={e => e.stopPropagation()}>
            <h3 style={{ color: '#2c0e16', fontWeight: 800, fontSize: '1.3rem', marginBottom: 8 }}>📱 Votre QR Code</h3>
            <p style={{ color: '#9e6575', fontSize: '0.85rem', marginBottom: 24 }}>Présentez ce QR Code à l'entrée de l'événement</p>
            <div style={{ background: '#fff', padding: 20, borderRadius: 16, border: '2px solid rgba(124,40,55,0.15)', display: 'inline-block', marginBottom: 24 }}>
              <img
                src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(qrModal.qrData)}`}
                alt="QR Code"
                style={{ width: 200, height: 200, display: 'block' }}
              />
            </div>
            <div style={{ fontSize: '0.78rem', color: '#9e6575', marginBottom: 20, wordBreak: 'break-all' }}>
              Code : {qrModal.qrData}
            </div>
            <button onClick={() => setQrModal(null)} style={{ background: 'linear-gradient(135deg,#7c2837,#a8384e)', color: '#fff', border: 'none', borderRadius: 12, padding: '12px 32px', fontWeight: 700, fontSize: '0.95rem', cursor: 'pointer' }}>
              Fermer
            </button>
          </div>
        </div>
      )}

      <div className="container">
        {/* Header */}
        <div style={{ 
          marginBottom: '50px',
          textAlign: 'center'
        }}>
          <h1 style={{
            fontSize: 'clamp(2.5rem, 5vw, 4rem)',
            fontWeight: '800',
            background: 'linear-gradient(135deg, #7c2837 0%, #943143 50%, #a8384e 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '1rem'
          }}>
            Événements
          </h1>
          <p style={{
            fontSize: '1.2rem',
            color: '#7a4050',
            marginBottom: '2rem'
          }}>
            Découvrez et participez aux événements organisés par la communauté
          </p>
          <button 
            style={{
              background: 'linear-gradient(135deg, #7c2837 0%, #943143 50%, #a8384e 100%)',
              color: 'white',
              border: 'none',
              padding: '16px 40px',
              borderRadius: '50px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 8px 24px rgba(124, 40, 55, 0.3)',
              transition: 'all 0.3s ease'
            }}
            onClick={() => window.location.href = '/events/new'}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 12px 32px rgba(124, 40, 55, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(124, 40, 55, 0.3)';
            }}
          >
            ➕ Organiser un événement
          </button>
        </div>

        {/* Filtres */}
        <div className="events-list-filter-card" style={{
          background: '#ffffff',
          borderRadius: '24px',
          padding: '32px',
          marginBottom: '50px',
          border: '1px solid rgba(124, 40, 55, 0.15)',
          boxShadow: '0 4px 20px rgba(124, 40, 55, 0.08)'
        }}>
          <form onSubmit={handleSearch} className="row g-3">
            <div className="col-md-5">
              <input
                type="text"
                style={{
                  width: '100%',
                  background: '#fdf6f8',
                  border: '1px solid rgba(124, 40, 55, 0.2)',
                  borderRadius: '16px',
                  padding: '14px 20px',
                  color: '#2c0e16',
                  fontSize: '1rem',
                  outline: 'none',
                  transition: 'all 0.3s ease'
                }}
                placeholder="🔍 Rechercher un événement..."
                value={filters.search}
                onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
                onFocus={(e) => e.currentTarget.style.borderColor = '#7c2837'}
                onBlur={(e) => e.currentTarget.style.borderColor = 'rgba(124, 40, 55, 0.2)'}
              />
            </div>
            <div className="col-md-4">
              <select
                style={{
                  width: '100%',
                  background: '#fdf6f8',
                  border: '1px solid rgba(124, 40, 55, 0.2)',
                  borderRadius: '16px',
                  padding: '14px 20px',
                  color: '#2c0e16',
                  fontSize: '1rem',
                  outline: 'none',
                  cursor: 'pointer'
                }}
                value={filters.registered ? 'registered' : (filters.upcoming ? 'upcoming' : (filters.past ? 'past' : 'all'))}
                onChange={(e) => {
                  const value = e.target.value;
                  setFilters(prev => ({
                    ...prev,
                    upcoming: value === 'upcoming',
                    past: value === 'past',
                    registered: value === 'registered'
                  }));
                }}
              >
                <option value="upcoming">📅 À venir</option>
                <option value="past">📚 Passés</option>
                <option value="registered">✅ Mes inscriptions</option>
                <option value="all">🗂️ Tous</option>
              </select>
            </div>
            <div className="col-md-3">
              <button 
                type="submit"
                style={{
                  width: '100%',
                  background: 'rgba(124, 40, 55, 0.2)',
                  border: '1px solid #7c2837',
                  borderRadius: '16px',
                  padding: '14px 20px',
                  color: 'white',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(124, 40, 55, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(124, 40, 55, 0.2)';
                }}
              >
                Filtrer
              </button>
            </div>
          </form>
        </div>

        {/* Liste des événements */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: '80px 0' }}>
            <div className="spinner-border" style={{ color: '#7c2837' }} role="status">
              <span className="visually-hidden">Chargement...</span>
            </div>
          </div>
        ) : (
          <>
            <div className="row">
              {events.map(event => (
                <div key={event.id} className="col-md-6 col-lg-4 mb-4">
                  <div 
                    style={{
                      background: '#ffffff',
                      borderRadius: '24px',
                      border: '1px solid rgba(124, 40, 55, 0.14)',
                      boxShadow: '0 2px 12px rgba(124, 40, 55, 0.06)',
                      overflow: 'hidden',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.borderColor = 'rgba(124, 40, 55, 0.5)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(124, 40, 55, 0.25)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.borderColor = 'rgba(124, 40, 55, 0.14)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    {/* Header */}
                    <div style={{
                      padding: '20px 24px',
                      borderBottom: '1px solid rgba(124, 40, 55, 0.1)',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                      <small style={{ color: '#9e6575', fontSize: '0.9rem' }}>
                        {event.club ? `🏛️ ${event.club.name}` : '🌍 Global'}
                      </small>
                      {getStatusBadge(event)}
                    </div>
                    
                    {/* Body */}
                    <div style={{ padding: '24px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                      <h5 style={{
                        color: '#2c0e16',
                        fontSize: '1.4rem',
                        fontWeight: '700',
                        marginBottom: '16px'
                      }}>
                        {event.title}
                      </h5>
                      
                      <p style={{ color: '#7a4050', fontSize: '0.95rem', marginBottom: '10px' }}>
                        📍 {event.location}
                      </p>
                      <p style={{ color: '#7a4050', fontSize: '0.95rem', marginBottom: '16px' }}>
                        🕐 {formatDate(event.start_date)}
                      </p>
                      <p style={{ 
                        color: '#8a5060', 
                        fontSize: '0.95rem', 
                        lineHeight: '1.6',
                        flex: 1,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical'
                      }}>
                        {event.description}
                      </p>
                      
                      <div className="events-list-card-actions" style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '20px',
                        paddingTop: '20px',
                        borderTop: '1px solid rgba(124, 40, 55, 0.1)'
                      }}>
                        <div>
                          <small style={{ color: '#9e6575', display: 'block', marginBottom: '6px' }}>
                            👥 {event.registered_count}/{event.capacity}
                          </small>
                          <strong style={{
                            color: '#e89aac',
                            fontSize: '1.2rem',
                            fontWeight: '700'
                          }}>
                            {event.user_price === 0 ? 'Gratuit' : `${event.user_price}€`}
                          </strong>
                        </div>
                        <button
                          style={{
                            background: 'rgba(124, 40, 55, 0.2)',
                            border: '1px solid #7c2837',
                            borderRadius: '12px',
                            padding: '10px 24px',
                            color: 'white',
                            fontSize: '0.95rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            marginRight: '10px'
                          }}
                          onClick={() => window.location.href = `/events/${event.id}`}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'linear-gradient(135deg, #7c2837 0%, #943143 50%, #a8384e 100%)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(124, 40, 55, 0.2)';
                          }}
                        >
                          Voir détails
                        </button>
                        {event.user_registered && (
                          <button
                            style={{
                              background: 'rgba(34, 197, 94, 0.15)',
                              border: '1px solid rgba(34, 197, 94, 0.4)',
                              borderRadius: '12px',
                              padding: '10px 16px',
                              color: '#4ade80',
                              fontSize: '0.9rem',
                              fontWeight: '600',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              marginRight: '10px'
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              fetchQrCode(event.id);
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = 'rgba(34, 197, 94, 0.25)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = 'rgba(34, 197, 94, 0.15)';
                            }}
                          >
                            📱 QR Code
                          </button>
                        )}
                        {event.is_organizer && (
                          <button
                            style={{
                              background: 'linear-gradient(135deg, #7c2837 0%, #943143 50%, #a8384e 100%)',
                              border: '1px solid #943143',
                              borderRadius: '12px',
                              padding: '10px 24px',
                              color: 'white',
                              fontSize: '0.95rem',
                              fontWeight: '600',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease'
                            }}
                            onClick={() => window.location.href = `/events/${event.id}/dashboard`}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = 'linear-gradient(135deg, #943143 0%, #a8384e 50%, #b8445e 100%)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = 'linear-gradient(135deg, #7c2837 0%, #943143 50%, #a8384e 100%)';
                            }}
                          >
                            👑 Gérer
                          </button>
                        )}
                      </div>
                    </div>

                    {/* Footer */}
                    <div style={{
                      padding: '16px 24px',
                      borderTop: '1px solid rgba(124, 40, 55, 0.1)',
                      background: 'rgba(124, 40, 55, 0.07)'
                    }}>
                      <small style={{ color: '#9e6575', fontSize: '0.85rem' }}>
                        Par {event.organizer.name} • {event.price_range}
                      </small>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {events.length === 0 && (
            <div style={{ 
              textAlign: 'center', 
              padding: '80px 40px',
              background: '#ffffff',
              borderRadius: '24px',
              border: '1px solid rgba(124, 40, 55, 0.15)',
              boxShadow: '0 4px 20px rgba(124, 40, 55, 0.08)'
            }}>
              <h3 style={{ color: '#2c0e16', fontSize: '2rem', marginBottom: '1rem' }}>
                🎭 Aucun événement trouvé
              </h3>
              <p style={{ color: '#7a4050', fontSize: '1.1rem', marginBottom: '2rem' }}>
                {filters.search ? 'Essayez avec d\'autres mots-clés' : 'Soyez le premier à organiser un événement !'}
              </p>
              <button 
                style={{
                  background: 'linear-gradient(135deg, #7c2837 0%, #943143 50%, #a8384e 100%)',
                  color: 'white',
                  border: 'none',
                  padding: '16px 40px',
                  borderRadius: '50px',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  boxShadow: '0 8px 24px rgba(124, 40, 55, 0.3)',
                  transition: 'all 0.3s ease'
                }}
                onClick={() => window.location.href = '/events/new'}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 12px 32px rgba(124, 40, 55, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(124, 40, 55, 0.3)';
                }}
              >
                ➕ Organiser un événement
              </button>
            </div>
          )}

          {/* Pagination */}
          {pagination.totalPages > 1 && (
            <nav style={{ marginTop: '50px' }}>
              <ul style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10px',
                listStyle: 'none',
                padding: 0,
                margin: 0
              }}>
                <li>
                  <button
                    style={{
                      background: pagination.currentPage === 1 ? '#f0e4e8' : 'rgba(124, 40, 55, 0.12)',
                      border: pagination.currentPage === 1 ? '1px solid rgba(168, 56, 78, 0.25)' : '1px solid #7c2837',
                      borderRadius: '12px',
                      padding: '10px 20px',
                      color: pagination.currentPage === 1 ? '#b0849a' : 'white',
                      cursor: pagination.currentPage === 1 ? 'not-allowed' : 'pointer',
                      transition: 'all 0.3s ease',
                      fontWeight: '600'
                    }}
                    onClick={() => pagination.currentPage > 1 && setPagination(prev => ({ ...prev, currentPage: prev.currentPage - 1 }))}
                    disabled={pagination.currentPage === 1}
                    onMouseEnter={(e) => {
                      if (pagination.currentPage !== 1) {
                        e.currentTarget.style.background = 'rgba(124, 40, 55, 0.3)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (pagination.currentPage !== 1) {
                        e.currentTarget.style.background = 'rgba(124, 40, 55, 0.2)';
                      }
                    }}
                  >
                    Précédent
                  </button>
                </li>
                
                {[...Array(pagination.totalPages)].map((_, index) => (
                  <li key={index + 1}>
                    <button
                      style={{
                        background: pagination.currentPage === index + 1 
                          ? 'linear-gradient(135deg, #7c2837 0%, #943143 50%, #a8384e 100%)' 
                          : 'rgba(124, 40, 55, 0.1)',
                        border: '1px solid ' + (pagination.currentPage === index + 1 ? '#7c2837' : 'rgba(168, 56, 78, 0.25)'),
                        borderRadius: '12px',
                        padding: '10px 18px',
                        color: 'white',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        fontWeight: '600',
                        minWidth: '50px'
                      }}
                      onClick={() => setPagination(prev => ({ ...prev, currentPage: index + 1 }))}
                      onMouseEnter={(e) => {
                        if (pagination.currentPage !== index + 1) {
                          e.currentTarget.style.background = 'rgba(124, 40, 55, 0.2)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (pagination.currentPage !== index + 1) {
                          e.currentTarget.style.background = 'rgba(124, 40, 55, 0.1)';
                        }
                      }}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
                
                <li>
                  <button
                    style={{
                      background: pagination.currentPage === pagination.totalPages ? '#f0e4e8' : 'rgba(124, 40, 55, 0.12)',
                      border: pagination.currentPage === pagination.totalPages ? '1px solid rgba(168, 56, 78, 0.25)' : '1px solid #7c2837',
                      borderRadius: '12px',
                      padding: '10px 20px',
                      color: pagination.currentPage === pagination.totalPages ? '#b0849a' : 'white',
                      cursor: pagination.currentPage === pagination.totalPages ? 'not-allowed' : 'pointer',
                      transition: 'all 0.3s ease',
                      fontWeight: '600'
                    }}
                    onClick={() => pagination.currentPage < pagination.totalPages && setPagination(prev => ({ ...prev, currentPage: prev.currentPage + 1 }))}
                    disabled={pagination.currentPage === pagination.totalPages}
                    onMouseEnter={(e) => {
                      if (pagination.currentPage !== pagination.totalPages) {
                        e.currentTarget.style.background = 'rgba(124, 40, 55, 0.3)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (pagination.currentPage !== pagination.totalPages) {
                        e.currentTarget.style.background = 'rgba(124, 40, 55, 0.2)';
                      }
                    }}
                  >
                    Suivant
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </>
      )}
      </div>
    </div>
  );
};

export default EventsList;